import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router';

import { useDispatch, useSelector } from 'react-redux';
import { closeSnackbar } from '../redux/ui/Actions';

// This Divider import looks like it does nothing but deleting it causes the autocomplete UI to mess up, no idea why
import { Divider, Snackbar, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import Header from './Header/Header';
// import Splash from "./splash/Splash";
import Preferences from './User/Preferences';
import ExpiredBody from '../../Auth/Components/Expired/ExpiredBody';
import VerifyingBody from '../../Auth/Components/Verifying/VerifyingBody';
import ActivationProtectedRoute from './ActivationProtectedRoute';
import NotFound from './Dashboard/Sites/NotFound';

const Dashboard = lazy(() => import('./Dashboard/Dashboard'));
import MapPage from './map/MapPage';
import Profile from './User/Profile';

const useStyles = makeStyles(theme => styles(theme));

function AppPage() {
    const classes = useStyles();

    const lastActivation = useSelector(state => state.user.lastActivation);
    const isActive = lastActivation && lastActivation.isActive;
    const hasDashboardAccess = useSelector(state =>
        Boolean(state?.user?.features?.dashboard?.enabled)
    );
    const snackbar = useSelector(state => state.uiReducer);
    const { snackbarOpen, snackbarSeverity, snackbarMessage } = snackbar;
    const dispatch = useDispatch();
    function dispatchCloseSnackbar() {
        dispatch(closeSnackbar());
    }

    // const temp = useSelector(state => state.purchaseDeedReducer);    
    // console.log(temp);    
    // 404 should redirect as opposed to stay on this page
    return (
        <div className={classes.root}>
            <Router basename="/app">
                <Header lite={!isActive} />
                <div className={classes.main}>
                    <Switch>
                        <Route path="/inactive">
                            {isActive ? (
                                <Redirect to="/map" />
                            ) : lastActivation && lastActivation.isExpired ? (
                                <ExpiredBody />
                            ) : (
                                <VerifyingBody />
                            )}
                        </Route>
                        <Route path="/preferences">
                            <Preferences />
                        </Route>
                        <Route path="/profile">
                            <Profile />
                        </Route>
                        <ActivationProtectedRoute path="/dashboard">
                            {hasDashboardAccess ? (
                                <Suspense fallback={<div>Loading...</div>}>
                                    <Dashboard />
                                </Suspense>
                            ) : (
                                <Redirect to="/map" />
                            )}
                        </ActivationProtectedRoute>
                        <ActivationProtectedRoute exact path="/map">
                            <Suspense fallback={<div>Loading...</div>}>
                                <MapPage key="mainmap" />
                            </Suspense>
                        </ActivationProtectedRoute>
                        <Route exact path="/">
                            <Redirect to="/map" />
                        </Route>
                        <Route path="/sitecards/not-found">
                            <NotFound errorText={"site card"}/>
                        </Route>
                        <Route path="*">
                            <p>404</p>
                        </Route>
                    </Switch>
                    {/* <Splash/> */}
                </div>
            </Router>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={dispatchCloseSnackbar}>
                <Alert
                    variant="filled"
                    onClose={dispatchCloseSnackbar}
                    severity={snackbarSeverity}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

const styles = theme => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.primary.main
    },
    main: {
        position: 'relative',
        flexGrow: 1,
        '& > div': {
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            zIndex: theme.zIndex.page
        }
    }
});

export default AppPage;
